"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domain = exports.getBrokerURLs = exports.privateURL = exports.appURL = exports.websiteURL = void 0;
var brokerURLs = {
    tk: 'signuptk.de',
    aok: 'signupaok.de',
    barmer: 'signupbarmer.de',
    dak: 'signupdak.de',
};
var brokerContactUrls = {
    tk: 'https://www.tk.de/service/app/2055914/contact/contact.app',
    aok: 'https://en.zuwanderer.aok.de/contact-with-aok',
    barmer: 'https://www.barmer.de/formClient/barmer-en/1053384/e-mail-service,step=form.html',
    dak: 'https://www.dak.de/dak/kontakt/contact-us-english-2258216.html',
};
/* We can introduce this part with microfrontends to have less confusion for devs */
// if (process.env.NODE_ENV === 'development') {
//   websiteURL = 'http://localhost:3001';
//   appURL = 'http://localhost:3000';
//   privateURL = 'http://localhost:3002';
// }
var stagingPrefix = process.env.REACT_APP_ENV === 'staging' ? 'staging.' : '';
var baseDomain = 'feather-insurance.com';
var featherDomain = "".concat(stagingPrefix).concat(baseDomain);
var appURL = "https://app.".concat(featherDomain);
exports.appURL = appURL;
var websiteURL = "https://".concat(featherDomain);
exports.websiteURL = websiteURL;
var privateURL = "https://health.".concat(featherDomain);
exports.privateURL = privateURL;
var getBrokerURLs = function (broker) { return ({
    landingPage: "https://".concat(stagingPrefix).concat(brokerURLs[broker]),
    signup: "https://register.".concat(broker, ".").concat(featherDomain),
    contact: brokerContactUrls[broker],
}); };
exports.getBrokerURLs = getBrokerURLs;
var cookieDomain = ".".concat(baseDomain);
exports.domain = cookieDomain;
